import { render, staticRenderFns } from "./TemplateManage.vue?vue&type=template&id=3eade81a&scoped=true"
import script from "./TemplateManage.vue?vue&type=script&lang=js"
export * from "./TemplateManage.vue?vue&type=script&lang=js"
import style0 from "./TemplateManage.vue?vue&type=style&index=0&id=3eade81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eade81a",
  null
  
)

export default component.exports